<template>
  <div class="header" v-if="!hideHeader">
    <TopHeader v-if="!webView"
      :showFinish="!isCustomerFlow"
      :showBack="isArchiveView"
      :disableFinish="finishButtonDisabled"
      :hideMinimize="webView"
      :mobile="mobile"
      @clickFinish="suspendConversation"
      @clickMinimize="minimize"
      @clickScrollToEnd="$emit('scrollToEnd')"
    />
    <transition name="fade">
      <div v-if="unreadMessages && showNewMessageAlertRef"
        key="unreadMessages"
        class="message-alert"
        @click="$emit('scrollToEnd')">
        <div class="msg-container">
          <Icon art="regular" color="black" name="long-arrow-alt-down" />
          <span class="text">{{ t('labels_newMessage' + (unreadMessages > 1 ? 's' : ''), { amount: unreadMessages }) }}</span>
        </div>
        <Icon
          class="right button close-icon"
          color="black"
          :width="14"
          :height="14"
          art="regular"
          name="xmark"
          @click.stop="showNewMessageAlertRef = false"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mapState, mapActions, mapGetters } from 'vuex'
import TopHeader from './TopHeader'
import Icon from './Icon'
import { useI36n } from '@jota-one/i36n/src/index.vue2'

export default {
  components: {
    Icon,
    TopHeader
  },
  name: 'ChatHeader',
  props: ['showNewMessageAlert', 'mobile'],

  setup (props) {
    const { $label: t } = useI36n()

    const showNewMessageAlertRef = ref(props.showNewMessageAlert)

    return { t, showNewMessageAlertRef }
  },

  computed: {
    ...mapState('conversation', ['conversation', 'unreadMessages']),
    ...mapState('uistate', ['conversationState', 'agentScreenName', 'agentAvatar', 'conversationState']),
    ...mapGetters('uistate', ['webView', 'isCustomerFlow', 'isArchiveView']),
    ...mapGetters('conversation', ['agentGender']),
    finishButtonDisabled () {
      return this.conversationState === 'CONVERSATION_SUSPENDED' ||
        this.conversationState === 'CONVERSATION_RATED' ||
        this.conversationState === 'CONVERSATION_ENDED' ||
        this.conversationState === 'CONVERSATION_RATING' ||
        this.conversationState === 'CONVERSATION_NEW'
    },
    isRealAgent () {
      return this.agentScreenName !== 'Sanitas'
    },
    hideHeader () {
      return this.webView && !this.isRealAgent
    }
  },
  methods: {
    ...mapActions('conversation', [
      'suspendConversation',
      'reset'
    ]),
    ...mapActions('uistate', [
      'minimizeFab',
      'close'
    ]),
    minimize () {
      let minimizableConversationStates = ['CONVERSATION_ENDED', 'CONVERSATION_RATING', 'CONVERSATION_SUSPENDED']
      if (this.agentScreenName !== 'Sanitas' || minimizableConversationStates.includes(this.conversationState)) {
        this.minimizeFab()
      } else {
        if (this.conversationState === 'CONVERSATION_RATED') {
          this.reset()
        }
        this.close('minimize')
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.header {
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: 20;
  .message-alert {
    background-color: var(--tw-c-yellow-light);
    color: var(--tw-c-black);
    cursor: pointer;
    position: absolute;
    left: 0;
    width: 100%;
    bottom: -40px;
    z-index: 2;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .msg-container {
      display: flex;
      .text {
        margin: auto 0;
      }
      .icon {
        margin: auto 5px auto 10px;
      }
    }
    .close-icon {
      margin: auto 10px auto auto;
    }
  }
  .middle {
    height: 80px;
    border-bottom: none;
    background-color: rgb(24, 63, 54);
    align-items: center;
    position: relative;
    display: flex;
    flex-direction: row;
    .profile-pic {
      width: 80px;
      height: 80px;
      .profile-pic-container {
        width: 100%;
        .image {
          width: 100%;
          height: 100%;
        }
      }
    }
    .content {
      margin-left: 20px;
      .legend {
        font-size: 15px;
      }
      .screen-name {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
}

</style>
